/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";
import { AnalyticsService } from "./@core/utils/analytics.service";
import { SeoService } from "./@core/utils/seo.service";
import { AuthService } from "./services/auth.service";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-app",
  styleUrls: ["./app.component.scss"],
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private authService: AuthService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.checkTokenExpiration();

    // Check token expiration every minute
    setInterval(() => {
      this.checkTokenExpiration();
    }, 60000);
  }

  private checkTokenExpiration() {
    const token = localStorage.getItem('access_token');
    if (this.authService.isTokenExpired(token)) {
      console.log('Token is expired');
      this.authService.logout();
      this.router.navigate(["/auth/login"]);
    } else {
      console.log('Token is not expired');
    }
  }



}
